import { render, staticRenderFns } from "./StripEdit.vue?vue&type=template&id=c284104a&scoped=true&"
import script from "./StripEdit.vue?vue&type=script&lang=js&"
export * from "./StripEdit.vue?vue&type=script&lang=js&"
import style0 from "./StripEdit.vue?vue&type=style&index=0&id=c284104a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c284104a",
  null
  
)

export default component.exports